import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cdwAeMatcherEditor]',
  standalone: false,
})
export class MatcherEditorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
